<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-09-30 14:31:56
 * @Version: 1.0
 * @Description:货源推荐页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <el-dialog
    :visible.sync="viewManager.visible"
    title="货源推荐"
    width="80%"
    @click="viewManager.close"
  >
    <div v-loading="viewManager.loading" class="recommend-dialog-head">
      <div class="slider-list">
        <div :class="{ 'selected': !recommendState}" class="item" @click="toggleRecommendState">智能推荐</div>
        <div :class="{ 'selected': recommendState}" class="item" @click="toggleRecommendState">常规推荐</div>
      </div>

      <div v-show="!recommendState" class="recommend-data">
        <div class="recommend-data-header">
          <ul>
            <li>公司名称</li>
            <li>联系人</li>
            <li>联系人电话</li>
            <li>公司地址</li>
            <li>路线</li>
            <li>运输方式</li>
            <li>重量</li>
            <li>货物名称</li>
            <li>操作</li>
          </ul>
        </div>
        <div class="recommend-data-body">
          <template v-if="recommendData.length===0 && !viewManager.loading">
            <div style="text-align: center;margin-top: 1rem;">暂无匹配数据</div>
          </template>
          <template v-for="(item, index) of recommendData">
            <div :key="index" class="data-item">
              <ul>
                <li :title="item.companyName">{{ item.companyName }}</li>
                <li :title="item.contacter">{{ item.contacter }}</li>
                <li :title="item.contacterTel">{{ item.contacterTel }}</li>
                <li :title="item.companyAddress">
                  <el-tooltip class="item" effect="dark" :content="item.companyAddress" placement="top">
                    <span>{{ item.companyAddress }}</span>
                  </el-tooltip>
                </li>
                <li :title="item.startPlaceLabel+'至'+item.stopPlaceLabel">
                  <el-tooltip class="item" effect="dark" :content="item.startPlaceLabel + '至' + item.stopPlaceLabel" placement="top">
                    <span>{{ item.startPlaceLabel }} 至 {{ item.stopPlaceLabel }}</span>
                  </el-tooltip>
                </li>
                <li :title="item.transportTypeLabel">{{ item.transportTypeLabel }}</li>
                <li :title="item.weight">{{ item.weight }}吨</li>
                <li
                  :title="item.goodsTypeLabel+ 'ᅳ' + item.goodsName"
                >{{ item.goodsTypeLabel }}ᅳ{{ item.goodsName }}</li>
                <li>
                  <el-button
                    class="yellow"
                    type="text"
                    @click="collect(item)"
                  >{{ item.favoritesFlag==='1'?'已收藏':'未收藏' }}</el-button>
                  <el-divider direction="vertical" />
                  <el-button
                    style="width:3rem"
                    :class="[{gray:isDisabledOffer(item)},{orange: !isDisabledOffer(item)}]"
                    type="text"
                    :disabled="isDisabledOffer(item)"
                    @click="quotation(item)"
                  >{{ item.offerType === 0 ? isDisabledOffer(item)? '已截止报价':'报价': item.offerType === 1 ?'已报价': '已拒绝报价' }}</el-button>
                  <!-- <el-divider direction="vertical" />
                  <el-button class="red" type="text" @click="agreeBid(item)">成交</el-button>-->
                </li>
              </ul>
            </div>
          </template>
        </div>
        <div class="recommend-data-pagination">
          <el-pagination
            :current-page="recommendPagination.pageNo"
            :total="recommendPagination.total"
            :page-size="recommendPagination.pageSize"
            layout="prev, pager, next, jumper,total, sizes"
            @current-change="recommendChangeCurrent"
            @size-change="recommendChangeSize"
          />
        </div>
      </div>

      <div v-show="recommendState" class="recommend-data">
        <el-form
          ref="recommendRoutineForm"
          :model="recommendRoutineForm"
          class="recommendRoutineForm"
          :inline="true"
        >
          <div class="condition-group">
            <el-form-item label="始发地" prop="startPlace">
              <el-cascader
                v-model="recommendRoutineForm.startPlace"
                style="width:200px"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
              />
            </el-form-item>
            <el-form-item label="目的地" prop="stopPlace">
              <el-cascader
                v-model="recommendRoutineForm.stopPlace"
                style="width:200px"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
              />
            </el-form-item>
            <el-form-item label="运输方式" prop="transportType">
              <el-select
                v-model="recommendRoutineForm.transportType"
                style="width:150px"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in transportType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="运输品类" prop="goodsType">
              <el-select
                v-model="recommendRoutineForm.goodsType"
                style="width:150px"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in goodsType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item class="form-item form-item-sou">
              <el-button
                size="small"
                style="background-color: #BE2316;border-color: #F56C6C;"
                class="form-item-btn"
                type="primary"
                @click="recommendRoutineSummit"
              >
                <i class="el-icon-search" />查询
              </el-button>
              <el-button
                size="small"
                style="background-color: #BE2316;border-color: #F56C6C;"
                class="form-item-btn"
                type="primary"
                @click="resetRecommendRoutineForm"
              >
                <i class="el-icon-delete-solid" />
                重置
              </el-button>
            </el-form-item>
          </div>
        </el-form>
        <div class="recommend-data-header">
          <ul>
            <li>公司名称</li>
            <li>联系人</li>
            <li>联系人电话</li>
            <li>公司地址</li>
            <li>路线</li>
            <li>运输方式</li>
            <li>重量</li>
            <li>货物名称</li>
            <li>操作</li>
          </ul>
        </div>
        <div class="recommend-data-body">
          <template v-if="recommendRoutineData.length===0 && !viewManager.loading">
            <div style="text-align: center;margin-top: 1rem;">暂无匹配数据</div>
          </template>
          <template v-for="(item, index) of recommendRoutineData">
            <div :key="index" class="data-item">
              <ul>
                <li :title="item.companyName">{{ item.companyName }}</li>
                <li :title="item.contacter">{{ item.contacter }}</li>
                <li :title="item.contacterTel">{{ item.contacterTel }}</li>
                <li :title="item.companyAddress">
                  <el-tooltip class="item" effect="dark" :content="item.companyAddress" placement="top">
                    <span>{{ item.companyAddress }}</span>
                  </el-tooltip>
                </li>
                <li :title="item.startPlaceLabel+'至'+item.stopPlaceLabel">
                  <el-tooltip class="item" effect="dark" :content="item.startPlaceLabel + '至' + item.stopPlaceLabel" placement="top">
                    <span>{{ item.startPlaceLabel }} 至 {{ item.stopPlaceLabel }}</span>
                  </el-tooltip>
                </li>
                <li :title="item.transportTypeLabel">{{ item.transportTypeLabel }}</li>
                <li :title="item.weight">{{ item.weight }}吨</li>
                <li :title="item.goodsTypeLabel+ 'ᅳ' + item.goodsName">{{ item.goodsTypeLabel }}ᅳ{{ item.goodsName }}</li>
                <li>
                  <el-button
                    class="yellow"
                    type="text"
                    @click="collect(item)"
                  >{{ item.favoritesFlag==='1'?'已收藏':'未收藏' }}</el-button>
                  <el-divider direction="vertical" />

                  <el-button
                    style="width:3rem"
                    :class="[{gray:isDisabledOffer(item)},{orange: !isDisabledOffer(item)}]"
                    type="text"
                    :disabled="isDisabledOffer(item)"
                    @click="quotation(item)"
                  >{{ item.offerType === 0 ? isDisabledOffer(item)? '已截止报价':'报价': item.offerType === 1 ?'已报价': '已拒绝报价' }}</el-button>
                  <!-- <el-divider direction="vertical" />
                  <el-button class="red" type="text" @click="agreeBid(item)">成交</el-button>-->
                </li>
              </ul>
            </div>
          </template>
        </div>
        <div class="recommend-data-pagination">
          <el-pagination
            :current-page="recommendRoutinePagination.pageNo"
            :total="recommendRoutinePagination.total"
            :page-size="recommendRoutinePagination.pageSize"
            layout="prev, pager, next, jumper,total, sizes"
            @current-change="recommendRoutineChangeCurrent"
            @size-change="recommendRoutineChangeSize"
          />
        </div>
      </div>
    </div>
    <!-- 报价对话框  -->
    <offer ref="offer-dialog" @done="load" />
  </el-dialog>
</template>

<script>
import { Page } from '@/utils/commonDataModel'
import { getwebMapList } from '@/api/personal/find/goodsManager'
// import { getArea, getDict } from '@/api/common'
import { conllection } from '@/api/cloud/storage-demand-info/storageDemandInfo'
import mixinsFunction from '@/utils/mixinsFunction'
import offer from '@/views/personal/transport/offer'
export default {
  name: 'GoodsRecommend',
  components: {
    offer
  },
  mixins: [mixinsFunction],
  data: function() {
    return {
      // 智能推荐所需要的货源参数
      recommendParam: {},
      // 地区
      area: [],
      // 运输方式
      transportType: [],
      transportId: '',
      // 货物类型
      goodsType: [],
      // 智能推荐分页
      recommendPagination: new Page(),
      // 常规推荐分页
      recommendRoutinePagination: new Page(),
      recommendState: false,
      recommendData: [],
      recommendRoutineParam: {},
      recommendRoutineData: [],
      recommendRoutineForm: {
        startPlace: '',
        stopPlace: '',
        goodsType: '',
        transportType: ''
      }
    }
  },
  created: function() {
    Promise.all([this.getArea(), this.getTransportType(), this.getGoodsType()]).then(res => {
      [this.area, this.transportType, this.goodsType] = res
    })
  },
  methods: {
    isDisabledOffer(goods) {
      // 如果已经报价则不再报价
      if (goods.offerType && goods.offerType != 0) {
        return true
      }
      // 报价时间已经截止则不再报价
      if (goods.expireDate) {
        if (goods.expireDate instanceof Date) {
          return goods.expireDate.getTime() < Date.now() - Date.now() % (1000 * 60 * 60 * 24)
        } else {
          return Date.parse(goods.expireDate) < Date.now() - Date.now() % (1000 * 60 * 60 * 24)
        }
      }
      return false
    },
    open(transport) {
      this.recommendParam = transport
      console.log(transport)
      this.transportId = transport.id

      if (this.recommendState) {
        this.recommendRoutineSummit()
      } else {
        this.loadRecommendData()
      }
      // this.recommendRoutineSummit()
      // this.loadRecommendData()
      this.viewManager.visible = true
    },
    // 报价后的刷新事件
    load() {
      if (this.recommendState) {
        this.recommendRoutineSummit()
      } else {
        this.loadRecommendData()
      }
    },
    // /* 获取地址 */
    // getArea() {
    //   return getArea()
    //     .then(data => {
    //       this.area = data.result
    //     })
    //     .catch(error => {
    //       console.error(error)
    //     })
    // },
    // // 获取运输方式
    // getTransportType() {
    //   return getDict('transportType')
    //     .then(data => {
    //       this.transportType = JSON.parse(data.result)
    //     })
    //     .catch(err => {
    //       console.error(err)
    //     })
    // },
    // // 获取货源类型
    // getGoodsType() {
    //   return getDict('goodsType')
    //     .then(data => {
    //       this.goodsType = JSON.parse(data.result)
    //     })
    //     .catch(err => {
    //       console.error(err)
    //     })
    // },
    recommendRoutineSummit() {
      this.recommendRoutineParam = this.exchangeRoutineData(
        this.recommendRoutineForm
      )
      this.loadRecommendRoutineData()
    },
    resetRecommendRoutineForm() {
      this.$refs['recommendRoutineForm'].resetFields()
      this.recommendRoutineParam = this.exchangeRoutineData(
        this.recommendRoutineForm
      )
      this.loadRecommendRoutineData()
    },
    // 切换推荐tab
    toggleRecommendState() {
      this.recommendState = !this.recommendState
      if (this.recommendState) {
        this.recommendRoutineSummit()
      } else {
        this.loadRecommendData()
      }
    },
    // 转换推荐参数
    exchangeRoutineData(data) {
      const handle = {
        get(target, key, proxy) {
          if (
            (key === 'startPlace' || key === 'stopPlace') &&
            target[key] &&
            target[key].length > 0
          ) {
            return target[key] instanceof Object && target[key][0]
              ? target[key].join('#') + '#'
              : target[key].toString()
          } else {
            return target[key]
          }
        }
      }
      if (window && window.Proxy) {
        const p = new Proxy(data, handle)
        return Object.assign({}, p)
      } else {
        const proxyData = {}
        for (const key in data) {
          proxyData[key] = handle.get(data, key)
        }
        return proxyData
      }
    },
    // 加载智能推荐数据
    loadRecommendData() {
      const param = {}
      param.goodsType = this.recommendParam.goodsType
      param.startPlace = this.recommendParam.startPlace
      param.stopPlace = this.recommendParam.stopPlace
      this.viewManager.loading = true
      getwebMapList(this.recommendPagination, param)
        .then(data => {
          this.recommendData = data.result.rows
          this.recommendPagination.total = data.result.total
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    // 加载常规请求数据
    loadRecommendRoutineData() {
      var param = this.recommendRoutineParam
      // console.log(param)
      // console.log(this.recommendRoutinePagination)
      this.viewManager.loading = true
      getwebMapList(this.recommendRoutinePagination, param)
        .then(data => {
          this.recommendRoutineData = data.result.rows
          // console.log(this.recommendRoutineData)
          this.recommendRoutinePagination.total = data.result.total
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    // 收藏
    collect(item) {
      // 请求未完成时重复点击
      if (item.collectionSubmit) {
        return false
      }
      item.collectionSubmit = true
      const favoritesFlag = item.favoritesFlag === '1' ? '2' : '1'
      // 发起收藏?取消收藏的请求
      conllection({
        id: item.collectionId,
        moduleId: item.id,
        moduleType: '1',
        collectionStatus: favoritesFlag
      })
        .then(data => {
          item.favoritesFlag = favoritesFlag
          item.collectionId = data.result.id
          this.$message({
            message: item.favoritesFlag == '1' ? '收藏成功' : '取消收藏成功',
            type: item.favoritesFlag == '1' ? 'success' : 'warning'
          })
          item.collectionSubmit = false
        })
        .catch(error => {
          console.error(error)
          item.collectionSubmit = false
        })
    },
    // 报价
    quotation(item) {
      this.$refs['offer-dialog'].open(item, this.transportId)
    },
    recommendChangeSize(size) {
      this.recommendPagination.pageSize = size
      this.loadRecommendData()
    },
    recommendChangeCurrent(current) {
      this.recommendPagination.pageNo = current
      this.loadRecommendData()
    },
    recommendRoutineChangeSize(size) {
      this.recommendRoutinePagination.pageSize = size
      this.loadRecommendRoutineData()
    },
    recommendRoutineChangeCurrent(current) {
      this.recommendRoutinePagination.pageNo = current
      this.loadRecommendRoutineData()
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;

.recommend-dialog-head {
  box-sizing: border-box;
  border-style: solid;
  border-width: 0 0 1px 0;
  border-color: #f1f1f1;
  background-color: #ffffff;
  .slider-list {
    display: block;
    margin: 0 0;
    height: 36px;
    overflow: auto;
    white-space: nowrap;
    border-bottom: 1px solid #f1f1f1;
    &::-webkit-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    &::-moz-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    .item {
      // height: 35px;
      height: calc(100% - 1px);
      display: inline-block;
      width: 100px;
      font-size: 16px;
      font-weight: 600;
      line-height: 35px;
      margin-right: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0);
      text-align: center;
      transition: all 1s;
      color: black;
      cursor: pointer;

      &.selected {
        border-bottom: 1px solid $main-color;
        transition: all 1s;
        color: $main-color;
      }
    }
  }
  .goods-head-form {
    padding-top: 1rem;
    display: flex;
    .fileds {
      flex: 0 1 75%;
      /deep/ .el-form-item {
        label:after {
          content: " : ";
        }
      }
    }
    .buttons {
      flex: 0 1 25%;
      display: inherit;
      align-items: center;
      justify-content: center;
    }
  }
}

.recommend-data {
  .recommendRoutineForm {
    .condition-group {
      margin-top: 0.5rem;
      padding-left: 8px;
    }
  }
  .recommend-data-header {
    color: $main-color;
    font-weight: bold;
    background-color: #ffffff;
    height: 45px;
    ul {
      display: flex;
      flex-wrap: nowrap;
      height: 100%;
      width: calc(100% - 16px);
      padding: 8px 8px;
      box-sizing: content-box;
      li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        min-width: 50px;
        height: 100%;
        line-height: 29px;
        text-align: center;
        &:nth-child(1) {
          flex-basis: 10%;
        }
        &:nth-child(2) {
          flex-basis: 10%;
        }
        &:nth-child(3) {
          flex-basis: 10%;
        }
        &:nth-child(4) {
          flex-basis: 10%;
        }
        &:nth-child(5) {
          flex-basis: 15%;
        }
        &:nth-child(6) {
          flex-basis: 10%;
        }
        &:nth-child(7) {
          flex-basis: 10%;
        }
        &:nth-child(8) {
          flex-basis: 10%;
        }
        &:nth-child(9) {
          flex-basis: 15%;
        }
      }
    }
  }
  .recommend-data-body {
    position: relative;
    .data-item {
      margin: 8px 0;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.09);
      border: 1px solid #ebeef5;
      position: relative;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 56px;
        width: calc(100% - 16px);
        padding: 8px 8px;
        position: relative;
        background-color: white;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 64px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 15%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 15%;
          }
        }
      }
      /deep/ .goods-item-details {
        border: 1px solid #ebeef5;
        z-index: 0;
      }
      .yellow {
        color: #e88e00;
      }
      .orange {
        color: #e3530c;
      }
      .red {
        color: #bf2316;
      }
    }
  }
  .recommend-data-pagination {
    margin-top: 24px;
    padding: 16px 0px;
    background-color: white;
  }
}

/deep/.el-form.quotation-form {
  display: flex;
  flex-direction: column;
  .form-line {
    display: flex;
    flex-direction: row;
    margin: auto;
    .quotation-label {
      line-height: 40px;
    }
    .quotation-form-btn {
      background-color: #a7a7a7 !important;
      color: white;
      border-radius: 15px;
      width: 100px;
    }
    .quotation-btn {
      background-color: #be2316 !important;
      margin-right: 2rem;
    }
  }
  .el-input {
    width: 90%;
    margin-right: 0.5rem;
    font-size: 24px;
    .el-input__inner {
      text-align: center;
      color: #ff0000 !important;
    }
  }
}
</style>
